import { guardNever } from "@hex/common";

import { FilterTabsPredicate } from "../../../workbench/state";
import { ContextWorkbenchEditorTab } from "../contextWorkbenchEditorTab";
import { ContextWorkbenchFileId } from "../contextWorkbenchFile";

export const editorTabMatchesFile =
  (
    fileId: ContextWorkbenchFileId,
  ): FilterTabsPredicate<ContextWorkbenchEditorTab> =>
  (tab) => {
    if (tab.type === ContextWorkbenchEditorTab.Type.FileEditor) {
      return tab.fileId === fileId;
    } else {
      guardNever(tab.type, tab.type);
      return false;
    }
  };
